import type { LevelDef } from '../level.ts';

// Two pairs of tight parallels crossing at right angles on landfill in the
// bay. Land two side by side on a pair and the level breathes; let the two
// crossing streams meet over the intersection and it does not. The pairs are
// rotated ~20° off the screen axes, as the real ones are off true north —
// square to the screen the four strips read as a hash mark, not an airport.
export const sanfrancisco: LevelDef = {
  id: 'sanfrancisco', city: 'san francisco', country: 'usa',
  blurb: 'bay fog, two tight pairs crossing square, room for none of it',
  baseline: 665, scoreMul: 2.2,
  capBase: 4, capDiv: 4, capMax: 6,
  spawnLead: [5, 11], minSpawnGap: 1.9, tempo: 1,
  mix: [['light', 0.22], ['medium', 0.30], ['heavy', 0.26], ['jet', 0.22]],
  layout: {
    runways: [
      { x1: -0.32, y1: 0.70, x2: -0.61, y2: -0.15, w: 24 },
      { x1: -0.04, y1: 0.60, x2: -0.33, y2: -0.25, w: 24 },
      { x1: -0.73, y1: 0.16, x2: 0.12, y2: -0.13, w: 24 },
      { x1: -0.63, y1: 0.42, x2: 0.22, y2: 0.13, w: 24 },
    ],
    pads: [],
  },
  palette: { bg: '#f2f4f6', field: '#e2e7e3', deep: '#d5dcd8', water: '#c3d4dd' },
  decor: ['goldengate', 'fog'],
  // the bay down the right-hand side, the landfill the runways sit on
  water: [{ x: 0.80, y: 0 }, { x: 0.72, y: 0.34 }, { x: 0.78, y: 0.66 }, { x: 0.70, y: 1 }, { x: 1, y: 1 }, { x: 1, y: 0 }],
  arrivalSides: [0.9, 0.9, 1.2, 1.2],
  // f4 major pentatonic: fog, the darkest filter and the longest room
  music: { root: 65, mode: 'major pentatonic', bpm: 56, wind: 0.8, verb: 0.9, bright: 1800, space: 5.0 },
};
